module.exports = __webpack_public_path__ + "static/media/app_store_badge.a9cb0120.svg";